<div *ngFor="let invoiceTableDataObject of selectedPayables$ | async">
  <div class="review-invoice">
    <div class="review-invoice__head">
      <div class="grid-row">
        <div class="grid-col">
          <h1 class="tc--white">{{ invoiceTableDataObject.getReviewTitle() }}</h1>
          <p class="mt--025">{{ configService.customerName }}</p>

          <!-- Do not show invoice download or error message if payable is for a prepayment -->
          <ng-container *ngIf="invoiceTableDataObject.getType() !== PayableType.PREPAYMENT">
            <div class="removed--xs review-invoice__filename" *ngIf="invoiceTableDataObject.invoice.invoiceFileId != null; else noInvoice">
              <div class="grid-row grid-row--aic grid-row--smg">
                <div class="grid-col grid-col--auto">
                  <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 384 512">
                    <path
                      fill="currentColor"
                      d="M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-8 171.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-.1 0-.1.1-.2.1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-74.1 255.3c4.1-2.7-2.5-11.9-42.8-9 37.1 15.8 42.8 9 42.8 9z"
                    ></path>
                  </svg>
                </div>
                <div class="grid-col"><span>Invoice_{{ invoiceTableDataObject.invoice.invoiceNumber }}.pdf</span></div>
                <div class="grid-col grid-col--auto">
                  <button
                    type="button"
                    (click)="invoicePdfService.exportInvoiceAsPDF(invoiceTableDataObject.invoice.arTran.id, invoiceTableDataObject.invoice.invoiceNumber)"
                    data-cy="export-pdf"
                  >
                    <svg
                      viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none"
                      stroke-linecap="round" stroke-linejoin="round"
                    >
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                      <polyline points="7 10 12 15 17 10"></polyline>
                      <line x1="12" y1="15" x2="12" y2="3"></line>
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <ng-template #noInvoice>
              <p class="mt--200 no-invoice">
                Invoice not available for download. Please contact
                <a
                  *ngIf="invoiceTableDataObject?.responsibleStaff?.email; else yourFirm"
                  [href]="'mailto:' + invoiceTableDataObject?.responsibleStaff?.email"
                >{{ invoiceTableDataObject?.responsibleStaff?.email }}</a>
                <ng-template #yourFirm>{{ configService.customerName }}</ng-template>
                for more information.
              </p>
            </ng-template>
          </ng-container>

        </div>

        <!-- Invoice image -->
        <a
          *ngIf="invoiceTableDataObject.getType() === PayableType.PREPAYMENT; else invoiceDownload"
          [routerLink]="['/', ROUTE_TOKEN_MAIN_BASE, ROUTE_TOKEN_ENGAGEMENTS_BASE, invoiceTableDataObject.getResourceId()]"
          class="grid-col grid-col--auto"
        >
          <img
            [src]="assetUriService.customerAssetUrl + 'stock-nextgen-pdf.svg'"
            height="192"
            class="review-invoice__image"
          >
        </a>
        <ng-template #invoiceDownload>
          <div
            [ngStyle]="{'pointer-events' : invoiceTableDataObject.invoice.invoiceFileId == null ? 'none' : 'inherit'}"
            (click)="invoicePdfService.previewInvoiceAsPDF(invoiceTableDataObject.invoice.arTran.id)"
            class="grid-col grid-col--auto"
          >
            <img
              [src]="assetUriService.customerAssetUrl + 'stock-nextgen-pdf.svg'"
              height="192"
              class="review-invoice__image"
            >
          </div>
        </ng-template>
      </div>
    </div>

    <div class="review-invoice__cont">
      <h4>Details</h4>

      <div class="mt--050 grid-row grid-row--aic grid-row--jcb">
        <div class="grid-col grid-col--auto grid-col--xs-12">Contact</div>
        <div
          class="grid-col grid-col--auto grid-col--xs-12 fw--300 tc--darkest"
        >{{ invoiceTableDataObject?.responsibleStaff?.firstName || " " }} {{ invoiceTableDataObject?.responsibleStaff?.lastName }}
          <span *ngIf="invoiceTableDataObject?.responsibleStaff?.firstName" class="tc--light"> | </span>
          <span
            [ngClass]="{'disabled' : invoiceTableDataObject.responsibleStaff === null || invoiceTableDataObject?.responsibleStaff?.email === null}"
            class="fw--400 text-button" (click)="sendAnEmail()" data-cy="send-an-email"
          ><a
            href="mailto:{{invoiceTableDataObject?.responsibleStaff?.email}}"
          >Send an Email</a></span></div>
      </div>

      <div class="mt--050 grid-row grid-row--aic grid-row--jcb">
        <div class="grid-col grid-col--auto grid-col--xs-12">Invoice Date</div>
        <div class="grid-col grid-col--auto grid-col--xs-12 fw--300 tc--darkest">
          {{ invoiceTableDataObject.getInvoiceDate() | date: 'longDate' }}
        </div>
      </div>

      <div class="mt--025 grid-row grid-row--aic grid-row--jcb">
        <div class="mt--025 grid-col grid-col--auto grid-col--xs-12">Status</div>
        <div class="mt--025 grid-col grid-col--auto grid-col--xs-12 fw--300 tc--darkest">
          <div *ngIf="invoiceTableDataObject?.overdue || invoiceTableDataObject.displayStatus === DUE_UPON_RECEIPT; then thenBlock else elseBlock"></div>
          <ng-template #thenBlock>
            <div *ngIf="invoiceTableDataObject.displayStatus !== DUE_UPON_RECEIPT" class="badge badge--error">
              <div class="badge__label">Overdue</div>
              <div class="badge__date">{{ invoiceTableDataObject.displayStatus }}</div>
            </div>
            <div
              *ngIf="invoiceTableDataObject.displayStatus === DUE_UPON_RECEIPT"
              class="text-emphasized"
            >{{ DUE_UPON_RECEIPT }}
            </div>
          </ng-template>
          <ng-template #elseBlock>
            <div class="badge badge--warning">
              <div class="badge__label">Due</div>
              <div class="badge__date">{{ invoiceTableDataObject.displayStatus }}</div>
            </div>
          </ng-template>
        </div>
      </div>

      <div class="mt--125 hr"></div>
      <div class="mt--125 grid-row grid-row--aic">
        <div class="grid-col">
          <h4>Bill Summary</h4>
        </div>
        <div *ngIf="configService.partialPaymentsEnabled" class="grid-col grid-col--auto">
          <div *ngIf="payPartialActive">
            Paying Partially -
            <button
              type="button" class="text-button text-button--error"
              (click)="deactivatePayPartial(invoiceTableDataObject)" data-cy="deactivate-partial-pay"
            >Cancel
            </button>
          </div>

          <div *ngIf="!payPartialActive && invoiceTableDataObject.canPayPartially()">
            <button
              type="button"
              class="text-button"
              (click)="activatePayPartial()"
              data-cy="activate-partial-pay"
            >Pay this Partially</button>
          </div>
        </div>
      </div>

      <div class="mt--050 grid-row grid-row--aic grid-row--jcb">
        <div class="grid-col grid-col--auto">Total Amount</div>
        <div class="grid-col grid-col--auto fw--300 tc--darkest">
          {{ invoiceTableDataObject.invoice.arTran.amount | currency : invoiceTableDataObject.currency?.code }}
        </div>
      </div>

      <div class="mt--025 grid-row grid-row--aic grid-row--jcb">
        <div class="grid-col grid-col--auto">Outstanding</div>
        <!-- TODO: Replace invoiceAmount with Outstanding Balance-->
        <div class="grid-col grid-col--auto h2">
          {{ (invoiceTableDataObject.invoice.arTran.amount - invoiceTableDataObject.invoice.arTran.allocated) | currency : invoiceTableDataObject.currency?.code }}
        </div>

        <div [hidden]="!payPartialActive" class="w-100">
          <div class="mt--075 partial-payment">
            <div class="grid-row grid-row--smg grid-row--aic">
              <div class="grid-col">
                <h4 class="tc--primary">Partial Payment:</h4>
              </div>
              <div class="grid-col grid-col--auto">
                <label>Amount:</label>
              </div>
              <div class="grid-col grid-col--3">
                <div class="form-control">
                  <div class="form-control__prefix">{{ invoiceTableDataObject.currency?.symbol }}</div>
                  <input
                    class="form-input partial-payment__input"
                    #payPartialInput
                    [ngModel]="amountToPay"
                    (ngModelChange)="amountToPay = $event"
                    (keyup)="updateAmountForPartialPayment(invoiceTableDataObject)"
                    (keyup.enter)="updateAmountForPartialPayment(invoiceTableDataObject)"
                    [ngClass]="valid ? 'form-input--valid' : 'form-input--invalid' "
                    min="0.01"
                    numberOnly
                    exceptions="."
                    [maxDecimalPlaces]="2"
                    data-cy="partial-payment-amount"
                  >
                </div>
              </div>
            </div>
          </div>

          <div
            *ngIf="getRemainingAfterPayment(invoiceTableDataObject) > 0"
            class="mt--050 p p--sm ta--right"
          >
            {{ getRemainingAfterPayment(invoiceTableDataObject) | currency : invoiceTableDataObject.currency?.code }}
            will still be {{ invoiceTableDataObject.overdue ? 'overdue' : 'due' }}
          </div>

          <div
            *ngIf="getRemainingAfterPayment(invoiceTableDataObject) < 0"
            class="mt--050 p p--sm ta--right"
          >
            Amount entered exceeds total amount
          </div>
        </div>
      </div>
    </div>
  </div>
